/**
 * The storefront endpoints of the acl-order module (cl=acl_order).
 *
 * Every action is two requests: the endpoint hands out a one-off action token,
 * the action itself carries it. The answer is an envelope { success, data, error },
 * also on a rejection, which the endpoint sends with its own http status code.
 */
import { postAction } from '../shell/request.js';

export const aclUrl = (fnc) => `/${URLSEGMENT}index.php?cl=acl_order&fnc=${fnc}`;

export async function aclAction(fnc, params) {
    let result;

    try {
        result = await postAction(aclUrl(fnc), params);
    } catch (failure) {
        if (!failure.payload) {
            throw failure;
        }
        result = failure.payload;
    }

    if (!result.success || !result.data) {
        throw new Error(result.error || `acl_order ${fnc} failed`);
    }

    return result.data;
}

export function actionToken(action, orderNumber, email = '') {
    return aclAction('issueActionToken', { action, orderNumber, email });
}

/** Returns the customer's personal url at the return portal. */
export async function returnPortalUrl(params) {
    return aclAction('returnRedirect', {
        ...params,
        actionToken: await actionToken('return', params.orderNumber, params.email),
    });
}
